var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 80,
    viewBox: "0 0 170 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_818_2323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0053 45.4329L62.6191 26.1113H70.0908L76.3764 38.6444L82.7095 26.1113H90.0002L79.6111 45.344V58.0135H73.0053V45.4359V45.4329Z",
    fill: "url(#paint0_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5493 26.1074H114.096V32.0774H100.111V38.9578H112.412V44.9278H100.111V52.0366H114.28V58.0066H93.5493V26.1074Z",
    fill: "url(#paint1_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.144 53.7272L121.061 48.8486C123.201 50.717 125.799 52.449 128.989 52.449C131.539 52.449 133.089 51.1737 133.089 49.3024V49.2579C133.089 47.6623 132.179 46.6599 127.622 44.9279C121.974 42.7422 118.463 40.598 118.463 35.1292V35.0373C118.463 29.4766 122.745 25.6953 128.897 25.6953C132.633 25.6953 136.277 26.9706 139.194 29.613L135.503 34.6251C133.499 32.985 131.174 31.6623 128.716 31.6623C126.439 31.6623 125.025 32.8012 125.025 34.4442V34.4886C125.025 36.3125 126.119 37.1756 131.085 39.2278C136.644 41.4165 139.651 43.7861 139.651 48.7537V48.8456C139.651 54.7711 135.141 58.416 128.944 58.416C124.888 58.416 120.652 57.0043 117.144 53.7213V53.7272Z",
    fill: "url(#paint2_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.877 53.7272L145.794 48.8486C147.935 50.717 150.532 52.449 153.722 52.449C156.272 52.449 157.823 51.1737 157.823 49.3024V49.2579C157.823 47.6623 156.913 46.6599 152.355 44.9279C146.707 42.7422 143.197 40.598 143.197 35.1292V35.0373C143.197 29.4766 147.478 25.6953 153.63 25.6953C157.366 25.6953 161.01 26.9706 163.928 29.613L160.236 34.6251C158.232 32.985 155.907 31.6623 153.45 31.6623C151.172 31.6623 149.758 32.8012 149.758 34.4442V34.4886C149.758 36.3125 150.852 37.1756 155.819 39.2278C161.378 41.4165 164.384 43.7861 164.384 48.7537V48.8456C164.384 54.7711 159.875 58.416 153.678 58.416C149.622 58.416 145.385 57.0043 141.877 53.7213V53.7272Z",
    fill: "url(#paint3_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7081 71.144H74.2514V67.511H72.8901V67.0898H76.0723V67.511H74.7111V71.144H74.7081Z",
    fill: "url(#paint4_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4423 67.5051H77.9689V68.8901H80.1813V69.3082H77.9689V70.7258H80.472V71.144H77.5122V67.0869H80.4453V67.5021L80.4423 67.5051Z",
    fill: "url(#paint5_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4477 70.5003C85.3439 70.6071 85.2342 70.705 85.1215 70.7939C85.0058 70.8799 84.8872 70.9541 84.7567 71.0164C84.6262 71.0786 84.4868 71.1261 84.3326 71.1617C84.1784 71.1973 84.0123 71.2151 83.8255 71.2151C83.5319 71.2151 83.262 71.1617 83.0159 71.052C82.7697 70.9452 82.5532 70.7969 82.3723 70.6071C82.1914 70.4173 82.049 70.1978 81.9452 69.9428C81.8414 69.6907 81.791 69.4149 81.791 69.1213C81.791 68.8277 81.8414 68.5578 81.9452 68.3057C82.0461 68.0507 82.1884 67.8282 82.3723 67.6355C82.5532 67.4427 82.7697 67.2944 83.0218 67.1817C83.2739 67.072 83.5467 67.0156 83.8433 67.0156C84.0301 67.0156 84.1962 67.0305 84.3445 67.0631C84.4928 67.0957 84.6322 67.1372 84.7597 67.1936C84.8872 67.2499 85.0058 67.3181 85.1126 67.3952C85.2194 67.4753 85.3261 67.5613 85.424 67.6592L85.1126 67.9943C84.9376 67.8312 84.7538 67.6977 84.5521 67.5939C84.3534 67.4901 84.1161 67.4397 83.8374 67.4397C83.6149 67.4397 83.4044 67.4812 83.2146 67.5672C83.0218 67.6533 82.8587 67.7689 82.7163 67.9202C82.574 68.0714 82.4672 68.2464 82.3871 68.451C82.3071 68.6527 82.2685 68.8722 82.2685 69.1094C82.2685 69.3467 82.3071 69.5661 82.3871 69.7708C82.4672 69.9754 82.5769 70.1533 82.7163 70.3046C82.8587 70.4558 83.0248 70.5745 83.2146 70.6605C83.4044 70.7465 83.612 70.791 83.8374 70.791C84.1161 70.791 84.3564 70.7406 84.5551 70.6368C84.7567 70.5359 84.9525 70.3906 85.1452 70.2038L85.4477 70.5003Z",
    fill: "url(#paint6_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2819 69.3201V71.144H86.8252V67.0869H87.2819V68.8901H89.6219V67.0869H90.0786V71.144H89.6219V69.3201H87.2819Z",
    fill: "url(#paint7_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7897 67.0898H95.2345V71.1469H94.8697L92.251 67.8194V71.1469H91.8062V67.0898H92.2362L94.7926 70.3403V67.0898H94.7897Z",
    fill: "url(#paint8_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.917 69.1094C100.917 69.3912 100.867 69.6581 100.766 69.9131C100.665 70.1652 100.523 70.3876 100.342 70.5834C100.161 70.7761 99.9419 70.9304 99.6869 71.0431C99.4319 71.1558 99.1503 71.2151 98.8419 71.2151C98.5336 71.2151 98.2519 71.1587 97.9999 71.046C97.7478 70.9333 97.5284 70.7821 97.3476 70.5923C97.1667 70.3995 97.0274 70.18 96.9266 69.925C96.8287 69.6729 96.7783 69.403 96.7783 69.1213C96.7783 68.8395 96.8287 68.5726 96.9295 68.3176C97.0303 68.0655 97.1697 67.8431 97.3535 67.6473C97.5344 67.4546 97.7538 67.3003 98.0088 67.1876C98.2637 67.0749 98.5454 67.0156 98.8538 67.0156C99.1621 67.0156 99.4438 67.072 99.6958 67.1847C99.9478 67.2974 100.164 67.4486 100.348 67.6384C100.529 67.8312 100.671 68.0507 100.769 68.3057C100.867 68.5578 100.917 68.8277 100.917 69.1094ZM100.443 69.1213C100.443 68.89 100.404 68.6705 100.324 68.4659C100.244 68.2612 100.135 68.0833 99.9923 67.932C99.85 67.7808 99.681 67.6622 99.4853 67.5732C99.2896 67.4842 99.0761 67.4397 98.8449 67.4397C98.6136 67.4397 98.4001 67.4812 98.2044 67.5702C98.0088 67.6562 97.8427 67.7748 97.7034 67.9261C97.564 68.0773 97.4543 68.2523 97.3772 68.457C97.2972 68.6586 97.2586 68.8781 97.2586 69.1094C97.2586 69.3407 97.2972 69.5602 97.3772 69.7648C97.4573 69.9695 97.567 70.1474 97.7093 70.2987C97.8516 70.4499 98.0206 70.5685 98.2163 70.6575C98.412 70.7465 98.6255 70.791 98.8567 70.791C99.088 70.791 99.3015 70.7495 99.4972 70.6605C99.6928 70.5745 99.8589 70.4558 99.9982 70.3046C100.138 70.1533 100.247 69.9784 100.327 69.7737C100.407 69.5721 100.446 69.3526 100.446 69.1213H100.443Z",
    fill: "url(#paint9_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.465 67.0898H102.922V70.7228H105.206V71.1469H102.465V67.0898Z",
    fill: "url(#paint10_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.355 69.1094C110.355 69.3912 110.304 69.6581 110.204 69.9131C110.103 70.1652 109.961 70.3876 109.78 70.5834C109.599 70.7761 109.379 70.9304 109.124 71.0431C108.869 71.1558 108.588 71.2151 108.279 71.2151C107.971 71.2151 107.689 71.1587 107.437 71.046C107.185 70.9333 106.966 70.7821 106.785 70.5923C106.604 70.3995 106.465 70.18 106.364 69.925C106.266 69.6729 106.216 69.403 106.216 69.1213C106.216 68.8395 106.266 68.5726 106.367 68.3176C106.468 68.0655 106.607 67.8431 106.791 67.6473C106.972 67.4546 107.191 67.3003 107.446 67.1876C107.701 67.0749 107.983 67.0156 108.291 67.0156C108.6 67.0156 108.881 67.072 109.133 67.1847C109.385 67.2974 109.602 67.4486 109.786 67.6384C109.966 67.8312 110.109 68.0507 110.207 68.3057C110.304 68.5578 110.355 68.8277 110.355 69.1094ZM109.88 69.1213C109.88 68.89 109.842 68.6705 109.762 68.4659C109.682 68.2612 109.572 68.0833 109.43 67.932C109.287 67.7808 109.118 67.6622 108.923 67.5732C108.727 67.4842 108.514 67.4397 108.282 67.4397C108.051 67.4397 107.838 67.4812 107.642 67.5702C107.446 67.6562 107.28 67.7748 107.141 67.9261C107.002 68.0773 106.892 68.2523 106.815 68.457C106.735 68.6586 106.696 68.8781 106.696 69.1094C106.696 69.3407 106.735 69.5602 106.815 69.7648C106.895 69.9695 107.004 70.1474 107.147 70.2987C107.289 70.4499 107.458 70.5685 107.654 70.6575C107.849 70.7465 108.063 70.791 108.294 70.791C108.526 70.791 108.739 70.7495 108.935 70.6605C109.13 70.5745 109.296 70.4558 109.436 70.3046C109.575 70.1533 109.685 69.9784 109.765 69.7737C109.845 69.5721 109.883 69.3526 109.883 69.1213H109.88Z",
    fill: "url(#paint11_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.414 70.5952C115.224 70.7643 114.993 70.9096 114.717 71.0312C114.441 71.1528 114.13 71.2121 113.786 71.2121C113.468 71.2121 113.184 71.1587 112.929 71.049C112.674 70.9422 112.457 70.7939 112.276 70.6041C112.098 70.4143 111.959 70.1919 111.864 69.9369C111.769 69.6818 111.722 69.409 111.722 69.1213C111.722 68.8336 111.772 68.5756 111.87 68.3205C111.968 68.0655 112.107 67.8401 112.285 67.6473C112.463 67.4546 112.677 67.3003 112.926 67.1876C113.175 67.0749 113.451 67.0156 113.756 67.0156C114.1 67.0156 114.388 67.0631 114.619 67.158C114.85 67.2529 115.067 67.3863 115.269 67.5554L114.972 67.9024C114.818 67.7689 114.646 67.6562 114.453 67.5702C114.26 67.4842 114.023 67.4397 113.738 67.4397C113.516 67.4397 113.308 67.4842 113.119 67.5732C112.929 67.6622 112.766 67.7808 112.632 67.932C112.496 68.0833 112.389 68.2583 112.312 68.4629C112.235 68.6646 112.196 68.8811 112.196 69.1094C112.196 69.3556 112.235 69.578 112.309 69.7856C112.383 69.9932 112.493 70.1711 112.632 70.3224C112.772 70.4736 112.938 70.5923 113.136 70.6753C113.332 70.7613 113.554 70.8028 113.804 70.8028C114.035 70.8028 114.254 70.7643 114.459 70.6842C114.664 70.6041 114.836 70.5092 114.975 70.3965V69.3852H113.741V68.9789H115.417V70.5923L115.414 70.5952Z",
    fill: "url(#paint12_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.576 71.144H118.117V69.5396L116.433 67.0869H116.99L118.354 69.1155L119.73 67.0869H120.263L118.579 69.5336V71.144H118.576Z",
    fill: "url(#paint13_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.245 68.0988C124.245 68.1937 124.26 68.2827 124.293 68.3598C124.322 68.4369 124.379 68.5081 124.462 68.5733C124.542 68.6386 124.655 68.6949 124.797 68.7483C124.939 68.8017 125.123 68.8492 125.346 68.8966C125.799 68.9974 126.135 69.1368 126.345 69.3148C126.559 69.4927 126.662 69.7389 126.662 70.0503C126.662 70.2252 126.627 70.3824 126.559 70.5278C126.49 70.6701 126.395 70.7917 126.274 70.8925C126.152 70.9934 126.007 71.0705 125.838 71.1239C125.669 71.1772 125.482 71.2039 125.28 71.2039C124.957 71.2039 124.661 71.1505 124.391 71.0467C124.121 70.94 123.866 70.7798 123.623 70.5604L123.907 70.2252C124.121 70.418 124.334 70.5604 124.551 70.6582C124.767 70.7531 125.016 70.8006 125.298 70.8006C125.58 70.8006 125.79 70.7354 125.957 70.6078C126.12 70.4803 126.203 70.3113 126.203 70.1037C126.203 70.0088 126.188 69.9227 126.155 69.8456C126.123 69.7715 126.069 69.7003 125.992 69.641C125.915 69.5787 125.808 69.5224 125.672 69.472C125.535 69.4215 125.36 69.3741 125.147 69.3266C124.916 69.2762 124.714 69.2169 124.542 69.1517C124.37 69.0864 124.228 69.0063 124.115 68.9144C124.002 68.8225 123.919 68.7127 123.866 68.5852C123.812 68.4607 123.786 68.3124 123.786 68.1463C123.786 67.9802 123.818 67.8349 123.884 67.6985C123.949 67.5591 124.041 67.4434 124.162 67.3455C124.281 67.2477 124.423 67.1706 124.586 67.1172C124.75 67.0638 124.927 67.0371 125.12 67.0371C125.417 67.0371 125.678 67.0786 125.9 67.1587C126.123 67.2388 126.336 67.3633 126.547 67.5265L126.28 67.8794C126.09 67.7252 125.9 67.6125 125.71 67.5442C125.521 67.476 125.319 67.4404 125.111 67.4404C124.844 67.4404 124.634 67.5057 124.48 67.6332C124.325 67.7607 124.248 67.9179 124.248 68.1018L124.245 68.0988Z",
    fill: "url(#paint14_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.135 69.1094C132.135 69.3912 132.085 69.6581 131.984 69.9131C131.883 70.1652 131.741 70.3876 131.56 70.5834C131.379 70.7761 131.16 70.9304 130.905 71.0431C130.65 71.1558 130.368 71.2151 130.06 71.2151C129.751 71.2151 129.47 71.1587 129.218 71.046C128.966 70.9333 128.746 70.7821 128.565 70.5923C128.384 70.3995 128.245 70.18 128.144 69.925C128.046 69.6729 127.996 69.403 127.996 69.1213C127.996 68.8395 128.046 68.5726 128.147 68.3176C128.248 68.0655 128.387 67.8431 128.571 67.6473C128.752 67.4546 128.972 67.3003 129.227 67.1876C129.482 67.0749 129.763 67.0156 130.072 67.0156C130.38 67.0156 130.662 67.072 130.914 67.1847C131.166 67.2974 131.382 67.4486 131.566 67.6384C131.747 67.8312 131.889 68.0507 131.987 68.3057C132.085 68.5578 132.135 68.8277 132.135 69.1094ZM131.661 69.1213C131.661 68.89 131.622 68.6705 131.542 68.4659C131.462 68.2612 131.352 68.0833 131.21 67.932C131.068 67.7808 130.899 67.6622 130.703 67.5732C130.507 67.4842 130.294 67.4397 130.063 67.4397C129.831 67.4397 129.618 67.4812 129.422 67.5702C129.227 67.6562 129.061 67.7748 128.921 67.9261C128.782 68.0773 128.672 68.2523 128.595 68.457C128.515 68.6586 128.476 68.8781 128.476 69.1094C128.476 69.3407 128.515 69.5602 128.595 69.7648C128.675 69.9695 128.785 70.1474 128.927 70.2987C129.069 70.4499 129.238 70.5685 129.434 70.6575C129.63 70.7465 129.843 70.791 130.075 70.791C130.306 70.791 130.519 70.7495 130.715 70.6605C130.911 70.5745 131.077 70.4558 131.216 70.3046C131.355 70.1533 131.465 69.9784 131.545 69.7737C131.625 69.5721 131.664 69.3526 131.664 69.1213H131.661Z",
    fill: "url(#paint15_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.683 67.0898H134.14V70.7228H136.423V71.1469H133.683V67.0898Z",
    fill: "url(#paint16_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.046 69.412C141.046 69.7056 141.004 69.9636 140.924 70.189C140.844 70.4115 140.729 70.6013 140.58 70.7496C140.432 70.9008 140.254 71.0135 140.047 71.0906C139.839 71.1677 139.608 71.2063 139.353 71.2063C139.097 71.2063 138.872 71.1677 138.664 71.0936C138.457 71.0194 138.279 70.9067 138.131 70.7585C137.982 70.6102 137.867 70.4263 137.787 70.2039C137.707 69.9844 137.665 69.7294 137.665 69.4447V67.0869H138.122V69.415C138.122 69.8539 138.231 70.192 138.451 70.4293C138.67 70.6636 138.973 70.7822 139.364 70.7822C139.756 70.7822 140.038 70.6695 140.257 70.4471C140.477 70.2246 140.586 69.8895 140.586 69.4447V67.0869H141.046V69.412Z",
    fill: "url(#paint17_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.238 71.144H143.782V67.511H142.42V67.0898H145.603V67.511H144.241V71.144H144.238Z",
    fill: "url(#paint18_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.538 67.0898V71.1469H147.082V67.0898H147.538Z",
    fill: "url(#paint19_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.264 69.1094C153.264 69.3912 153.213 69.6581 153.112 69.9131C153.012 70.1652 152.869 70.3876 152.688 70.5834C152.507 70.7761 152.288 70.9304 152.033 71.0431C151.778 71.1558 151.496 71.2151 151.188 71.2151C150.88 71.2151 150.598 71.1587 150.346 71.046C150.094 70.9333 149.875 70.7821 149.694 70.5923C149.513 70.3995 149.374 70.18 149.273 69.925C149.175 69.6729 149.125 69.403 149.125 69.1213C149.125 68.8395 149.175 68.5726 149.276 68.3176C149.377 68.0655 149.516 67.8431 149.7 67.6473C149.881 67.4546 150.1 67.3003 150.355 67.1876C150.61 67.0749 150.892 67.0156 151.2 67.0156C151.508 67.0156 151.79 67.072 152.042 67.1847C152.294 67.2974 152.51 67.4486 152.694 67.6384C152.875 67.8312 153.017 68.0507 153.115 68.3057C153.213 68.5578 153.264 68.8277 153.264 69.1094ZM152.789 69.1213C152.789 68.89 152.751 68.6705 152.671 68.4659C152.591 68.2612 152.481 68.0833 152.338 67.932C152.196 67.7808 152.027 67.6622 151.832 67.5732C151.636 67.4842 151.422 67.4397 151.191 67.4397C150.96 67.4397 150.746 67.4812 150.551 67.5702C150.355 67.6562 150.189 67.7748 150.05 67.9261C149.91 68.0773 149.801 68.2523 149.723 68.457C149.643 68.6586 149.605 68.8781 149.605 69.1094C149.605 69.3407 149.643 69.5602 149.723 69.7648C149.803 69.9695 149.913 70.1474 150.056 70.2987C150.198 70.4499 150.367 70.5685 150.563 70.6575C150.758 70.7465 150.972 70.791 151.203 70.791C151.434 70.791 151.648 70.7495 151.843 70.6605C152.039 70.5745 152.205 70.4558 152.344 70.3046C152.484 70.1533 152.593 69.9784 152.674 69.7737C152.754 69.5721 152.792 69.3526 152.792 69.1213H152.789Z",
    fill: "url(#paint20_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.791 67.0898H158.236V71.1469H157.871L155.252 67.8194V71.1469H154.808V67.0898H155.238L157.794 70.3403V67.0898H157.791Z",
    fill: "url(#paint21_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.317 68.0988C160.317 68.1937 160.331 68.2827 160.364 68.3598C160.394 68.4369 160.45 68.5081 160.533 68.5733C160.613 68.6386 160.726 68.6949 160.868 68.7483C161.011 68.8017 161.194 68.8492 161.417 68.8966C161.871 68.9974 162.206 69.1368 162.416 69.3148C162.63 69.4927 162.734 69.7389 162.734 70.0503C162.734 70.2252 162.698 70.3824 162.63 70.5278C162.562 70.6701 162.467 70.7917 162.345 70.8925C162.224 70.9934 162.078 71.0705 161.909 71.1239C161.74 71.1772 161.553 71.2039 161.352 71.2039C161.028 71.2039 160.732 71.1505 160.462 71.0467C160.192 70.94 159.937 70.7798 159.694 70.5604L159.979 70.2252C160.192 70.418 160.406 70.5604 160.622 70.6582C160.839 70.7531 161.088 70.8006 161.369 70.8006C161.651 70.8006 161.862 70.7354 162.028 70.6078C162.191 70.4803 162.274 70.3113 162.274 70.1037C162.274 70.0088 162.259 69.9227 162.227 69.8456C162.194 69.7715 162.141 69.7003 162.063 69.641C161.986 69.5787 161.88 69.5224 161.743 69.472C161.607 69.4215 161.432 69.3741 161.218 69.3266C160.987 69.2762 160.785 69.2169 160.613 69.1517C160.441 69.0864 160.299 69.0063 160.186 68.9144C160.073 68.8225 159.99 68.7127 159.937 68.5852C159.884 68.4607 159.857 68.3124 159.857 68.1463C159.857 67.9802 159.89 67.8349 159.955 67.6985C160.02 67.5591 160.112 67.4434 160.234 67.3455C160.352 67.2477 160.495 67.1706 160.658 67.1172C160.821 67.0638 160.999 67.0371 161.192 67.0371C161.488 67.0371 161.749 67.0786 161.972 67.1587C162.194 67.2388 162.407 67.3633 162.618 67.5265L162.351 67.8794C162.161 67.7252 161.972 67.6125 161.782 67.5442C161.592 67.476 161.39 67.4404 161.183 67.4404C160.916 67.4404 160.705 67.5057 160.551 67.6332C160.397 67.7607 160.32 67.9179 160.32 68.1018L160.317 68.0988Z",
    fill: "url(#paint22_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6203 67.3899C10.6529 71.2068 10.6322 75.0237 10.6351 78.8405C10.6351 79.1786 10.6648 79.5167 10.6855 79.9764C10.6944 79.9764 10.7033 79.9764 10.7122 79.9764V66.5625C10.65 66.8205 10.6173 67.0934 10.6203 67.3899Z",
    fill: "url(#paint23_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8666 12.9249C35.6441 13.1444 35.4632 13.3668 35.3149 13.5982V69.4039C36.1068 68.618 36.8957 67.8261 37.6905 67.0432C37.9544 66.7822 38.1591 66.5183 38.3133 66.2425V10.502C37.4977 11.3086 36.6851 12.1183 35.8695 12.9249H35.8666Z",
    fill: "url(#paint24_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3096 10.5015V66.242C38.3244 66.2153 38.3392 66.1857 38.3541 66.156V10.457C38.3392 10.4719 38.3244 10.4867 38.3096 10.5015Z",
    fill: "url(#paint25_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4082 46.337V74.3037C31.4047 73.3013 32.4041 72.3048 33.4065 71.3053V42.0664C32.6948 43.6086 31.7013 45.0351 30.4082 46.337Z",
    fill: "url(#paint26_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2466 13.7044V69.4716C35.2703 69.4479 35.2911 69.4271 35.3148 69.4034V13.5977C35.2911 13.6332 35.2703 13.6688 35.2466 13.7044Z",
    fill: "url(#paint27_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4023 42.0656V71.3046C33.4023 71.3046 33.432 71.2749 33.4468 71.2601V41.9678C33.432 42.0004 33.4172 42.033 33.4023 42.0656Z",
    fill: "url(#paint28_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5015 51.2385V79.2289C25.5964 79.1488 25.6883 79.0628 25.7802 78.9679C26.6848 78.0515 27.5923 77.141 28.4998 76.2276V48.2432C27.5033 49.2426 26.5009 50.2391 25.5015 51.2356V51.2385Z",
    fill: "url(#paint29_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3784 46.3685C30.3784 46.3685 30.3517 46.3922 30.3398 46.4071V74.3737C30.3636 74.35 30.3843 74.3292 30.4081 74.3055V46.3389C30.4081 46.3389 30.3903 46.3596 30.3784 46.3685Z",
    fill: "url(#paint30_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4956 48.2457V76.2301C28.5104 76.2153 28.5253 76.2004 28.5401 76.1856V48.2012C28.5253 48.216 28.5104 48.2308 28.4956 48.2457Z",
    fill: "url(#paint31_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5943 56.1379V79.9733C21.5018 79.9792 22.4093 79.9852 23.3138 79.997C23.4087 79.997 23.5007 79.9941 23.5896 79.9881V53.1455C22.5902 54.142 21.5937 55.1414 20.5913 56.1349L20.5943 56.1379Z",
    fill: "url(#paint32_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4331 51.3065V79.282C25.4568 79.2642 25.4776 79.2494 25.5013 79.2286V51.2383C25.4776 51.262 25.4568 51.2828 25.4331 51.3065Z",
    fill: "url(#paint33_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5889 53.149V79.9916C23.5889 79.9916 23.6185 79.9916 23.6334 79.9916V53.1045C23.6185 53.1193 23.6037 53.1342 23.5889 53.149Z",
    fill: "url(#paint34_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 61.0108V79.9676C16.6899 79.9676 17.6894 79.9676 18.6858 79.9676V58.0332C17.6864 59.0267 16.6869 60.0173 15.6875 61.0078V61.0108Z",
    fill: "url(#paint35_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5264 56.2059V79.976C20.5501 79.976 20.5709 79.976 20.5946 79.976V56.1406C20.5709 56.1644 20.5501 56.1851 20.5264 56.2088V56.2059Z",
    fill: "url(#paint36_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6816 58.0357V79.9701C18.6816 79.9701 18.7113 79.9701 18.7261 79.9701V57.9912C18.7261 57.9912 18.6965 58.0209 18.6816 58.0357Z",
    fill: "url(#paint37_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7755 62.9092C13.043 63.6358 12.3104 64.3653 11.5779 65.0919C11.1241 65.5427 10.8424 66.0143 10.7119 66.5629V79.9768C11.741 79.9768 12.7612 79.9768 13.7755 79.9739V62.9092Z",
    fill: "url(#paint38_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6191 61.0789V79.9705C15.6429 79.9705 15.6636 79.9705 15.6874 79.9705V61.0137C15.6636 61.0344 15.6429 61.0582 15.6191 61.0819V61.0789Z",
    fill: "url(#paint39_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7749 62.9078V79.9725C13.7749 79.9725 13.8046 79.9725 13.8194 79.9725V62.8633C13.8046 62.8781 13.7897 62.8929 13.7749 62.9078Z",
    fill: "url(#paint40_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2192 8.61035V37.8078C40.9399 36.2893 41.9305 34.8747 43.2087 33.5787V5.63574C42.2152 6.62925 41.2157 7.6198 40.2192 8.61035Z",
    fill: "url(#paint41_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1445 8.68352V37.958C40.1683 37.9076 40.1949 37.8572 40.2187 37.8068V8.60938C40.1949 8.6331 40.1683 8.65683 40.1445 8.68352Z",
    fill: "url(#paint42_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2109 5.63433V33.5772C43.2258 33.5624 43.2406 33.5476 43.2554 33.5298V5.58984C43.2406 5.60467 43.2258 5.6195 43.2109 5.63433Z",
    fill: "url(#paint43_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0354 0.809422C47.0656 1.78217 46.0929 2.75196 45.1201 3.72175V31.6706C46.1166 30.68 47.1131 29.6865 48.1096 28.696V0.741211C48.0829 0.764937 48.0591 0.785697 48.0324 0.812388L48.0354 0.809422Z",
    fill: "url(#paint44_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0464 3.79875V31.7446C45.0701 31.7209 45.0968 31.6942 45.1205 31.6705V3.72461C45.0968 3.74834 45.0701 3.77503 45.0464 3.79875Z",
    fill: "url(#paint45_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1089 0.740739V28.6955C48.1089 28.6955 48.1385 28.6659 48.1534 28.651V0.699219C48.1385 0.714047 48.1237 0.72591 48.1089 0.740739Z",
    fill: "url(#paint46_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.021 0V26.7922C51.0175 25.8017 52.0139 24.8082 53.0104 23.8176V0.0118628C52.0139 0.00889713 51.0175 0.0118628 50.021 0Z",
    fill: "url(#paint47_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9591 0C49.9591 0 49.9502 0 49.9473 0V26.8664C49.971 26.8426 49.9977 26.8159 50.0214 26.7922V0C50.0006 0 49.9799 0 49.9591 0Z",
    fill: "url(#paint48_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0098 0.0117188V23.8175C53.0098 23.8175 53.0394 23.7878 53.0543 23.773V0.0117188C53.0394 0.0117188 53.0246 0.0117188 53.0098 0.0117188Z",
    fill: "url(#paint49_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9194 0.0185547V21.9203C55.9159 20.9298 56.9124 19.9392 57.9089 18.9487V0.0215204C56.9124 0.0215204 55.9159 0.0215204 54.9194 0.0215204V0.0185547Z",
    fill: "url(#paint50_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8452 0.0185547V21.9945C54.8689 21.9707 54.8956 21.944 54.9194 21.9203V0.0185547C54.8956 0.0185547 54.8689 0.0185547 54.8452 0.0185547Z",
    fill: "url(#paint51_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9166 14.9648C62.5246 14.3628 62.8301 13.737 62.8241 12.8621C62.7915 8.94147 62.8123 5.0208 62.8063 1.10013C62.8063 0.767975 62.7618 0.435815 62.7292 0.0117188H61.6111C61.0121 0.0117188 60.416 0.0117188 59.8169 0.0117188V17.0497C60.5168 16.3557 61.2137 15.6588 61.9137 14.9648H61.9166Z",
    fill: "url(#paint52_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9106 0.0205078V18.9477C57.9106 18.9477 57.9403 18.918 57.9551 18.9032V0.0205078C57.9403 0.0205078 57.9255 0.0205078 57.9106 0.0205078Z",
    fill: "url(#paint53_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7461 17.1248C59.7698 17.101 59.7965 17.0743 59.8202 17.0506V0.0185547C59.7965 0.0185547 59.7698 0.0185547 59.7461 0.0185547V17.1248Z",
    fill: "url(#paint54_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.311 58.1645C167.994 58.1645 167.706 58.0874 167.448 57.9361C167.19 57.7849 166.982 57.5773 166.825 57.3192C166.671 57.0612 166.591 56.7765 166.591 56.4651C166.591 56.1537 166.668 55.8572 166.825 55.5991C166.979 55.3411 167.187 55.1365 167.448 54.9823C167.706 54.831 167.994 54.7539 168.311 54.7539C168.628 54.7539 168.907 54.831 169.162 54.9823C169.417 55.1365 169.622 55.3411 169.773 55.5991C169.924 55.8572 170.001 56.1478 170.001 56.4651C170.001 56.7825 169.924 57.0612 169.773 57.3192C169.622 57.5773 169.417 57.7849 169.162 57.9361C168.907 58.0903 168.622 58.1645 168.311 58.1645ZM168.311 57.8471C168.584 57.8471 168.821 57.7849 169.026 57.6573C169.23 57.5298 169.393 57.3637 169.509 57.1561C169.625 56.9485 169.684 56.7172 169.684 56.4651C169.684 56.213 169.625 55.9728 169.509 55.7652C169.393 55.5576 169.233 55.3886 169.026 55.264C168.821 55.1394 168.581 55.0742 168.311 55.0742C168.041 55.0742 167.798 55.1365 167.584 55.264C167.371 55.3915 167.208 55.5576 167.092 55.7652C166.976 55.9758 166.917 56.2071 166.917 56.4651C166.917 56.7231 166.976 56.9485 167.092 57.1561C167.208 57.3667 167.371 57.5328 167.584 57.6573C167.795 57.7849 168.038 57.8471 168.311 57.8471ZM167.664 57.2896V55.5487H168.29C168.521 55.5487 168.702 55.5873 168.827 55.6614C168.954 55.7385 169.017 55.872 169.017 56.0647C169.017 56.2041 168.978 56.3198 168.901 56.4117C168.824 56.5037 168.708 56.5511 168.548 56.5511C168.673 56.5511 168.759 56.5838 168.803 56.646C168.845 56.7083 168.871 56.7795 168.877 56.8596C168.883 56.9396 168.901 57.0019 168.928 57.0494C168.954 57.0968 169.011 57.0998 169.097 57.0583V57.2481C169.043 57.2896 168.978 57.3104 168.904 57.3192C168.827 57.3252 168.759 57.3044 168.699 57.2481C168.64 57.1947 168.61 57.0998 168.61 56.9604C168.61 56.8477 168.599 56.7617 168.575 56.7024C168.551 56.6431 168.498 56.6045 168.412 56.5837C168.326 56.563 168.18 56.5541 167.976 56.5541V57.2896H167.667H167.664ZM167.973 56.3435H168.29C168.435 56.3435 168.545 56.3287 168.619 56.302C168.691 56.2753 168.729 56.2071 168.729 56.0944C168.729 55.961 168.685 55.8809 168.596 55.8512C168.507 55.8216 168.382 55.8067 168.222 55.8067H167.973V56.3435Z",
    fill: "url(#paint55_linear_818_2323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7947C0 12.946 0.00889713 13.0854 0.0237257 13.2248V9.99512C0.02076 10.9293 0.0118628 11.8605 0 12.7947Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1609 39.2168C28.1312 33.6709 28.1045 28.122 28.0601 22.5762V39.9167C28.0601 39.9167 28.0749 39.9315 28.0838 39.9374C28.1342 39.4837 28.1609 39.3502 28.1609 39.2168Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0234375 3.49414V9.99498C0.0323346 7.82704 0.0264032 5.66207 0.0234375 3.49414Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01695 15.0449C1.72279 15.6944 2.42863 16.3438 3.13447 16.9933V0.0146484C2.60954 0.0146484 2.08757 0.0146484 1.56264 0.0146484H0.0234375V3.49342C0.0264032 5.66136 0.0323346 7.82633 0.0234375 9.99426V13.2239C0.106477 13.9624 0.438637 14.514 1.01695 15.0449Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13379 0.0146484V16.9933C3.14862 17.0082 3.16345 17.02 3.17827 17.0349V0.0146484C3.16345 0.0146484 3.14862 0.0146484 3.13379 0.0146484Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07617 0.0127313V18.7797C6.08748 19.711 7.10175 20.6422 8.11306 21.5734V0.00976562C7.10175 0.00976562 6.08748 0.00976562 5.07617 0.00976562V0.0127313Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 0.0126953V18.7115C5.02275 18.7352 5.04944 18.7589 5.07317 18.7797V0.0126953C5.04944 0.0126953 5.02275 0.0126953 4.99902 0.0126953Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11182 0.00976562V21.5734C8.12664 21.5883 8.14147 21.6001 8.1563 21.615V0.00976562C8.14147 0.00976562 8.12664 0.00976562 8.11182 0.00976562Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0513 0.0146484C11.0003 0.0205799 11.9464 0.0324427 12.8954 0.0472712C12.9577 0.0472712 13.0229 0.0532027 13.0882 0.0620998",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8954 0.0511775C11.9464 0.0333832 11.0003 0.0244861 10.0513 0.0185547V23.3587C11.0626 24.2899 12.0768 25.2211 13.0882 26.1524V0.0630403C13.0229 0.0571089 12.9577 0.0511775 12.8954 0.0482118V0.0511775Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97705 0.0146484V23.2895C10.0008 23.3133 10.0275 23.337 10.0512 23.3577V0.0146484C10.0275 0.0146484 10.0008 0.0146484 9.97705 0.0146484Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1314 26.1958C13.1166 26.181 13.1017 26.1691 13.0869 26.1543L13.1314 26.1958Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0869 0.0625C13.1017 0.0625 13.1166 0.0625 13.1314 0.0654657L13.0869 0.0625Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0869 0.0625V26.1518C13.1017 26.1667 13.1166 26.1785 13.1314 26.1934V0.0684314C13.1166 0.0684314 13.1017 0.0684314 13.0869 0.0654657V0.0625Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0293 1.10742C16.0465 2.1039 17.0549 3.10631 18.0662 4.10872L15.0293 1.10742Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0293 1.10742V27.9441C16.0406 28.8783 17.0549 29.8096 18.0662 30.7438V4.10872C17.0549 3.10928 16.0465 2.1039 15.0293 1.10742Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9526 1.0332C14.9764 1.05693 15.0031 1.08362 15.0268 1.10735L14.9526 1.0332Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0292 27.9432C15.0055 27.9195 14.9788 27.8958 14.9551 27.875L15.0292 27.9432Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9526 1.0332V27.8729C14.9764 27.8966 15.0031 27.9203 15.0268 27.9411V1.10735C15.0031 1.08362 14.9764 1.05693 14.9526 1.0332Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0659 4.10742C18.0807 4.12225 18.0956 4.13708 18.1104 4.15191L18.0659 4.10742Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1099 30.7818C18.0951 30.7669 18.0803 30.7551 18.0654 30.7402L18.1099 30.7818Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0659 4.10742V30.7395C18.0807 30.7543 18.0956 30.7662 18.1104 30.781V4.15191C18.0956 4.13708 18.0807 4.12225 18.0659 4.10742Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0044 6.02441C21.0187 7.03276 22.03 8.04703 23.0413 9.0613L20.0044 6.02441Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0044 6.02441V32.529C21.0157 33.4632 22.03 34.3944 23.0413 35.3286V9.06427C22.03 8.04999 21.0187 7.03572 20.0044 6.02738V6.02441Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9302 5.9502C19.9539 5.97392 19.9806 6.00061 20.0043 6.02434L19.9302 5.9502Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0043 32.5282C19.9806 32.5044 19.9539 32.4807 19.9302 32.46L20.0043 32.5282Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9302 5.9502V32.4607C19.9539 32.4844 19.9806 32.5081 20.0043 32.5289V6.02434C19.9806 6.00061 19.9539 5.97392 19.9302 5.9502Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9824 11.0146C25.7298 11.7679 26.4801 12.5153 27.2245 13.2686C27.6427 13.6927 27.9867 14.4045 27.9926 14.9857C28.0223 17.5155 28.046 20.0452 28.0638 22.575",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9926 14.9857C27.9867 14.4045 27.6427 13.6927 27.2245 13.2686C26.4801 12.5153 25.7298 11.7679 24.9824 11.0146V37.1129L28.0638 41.2767V22.5779C28.043 20.0482 28.0223 17.5184 27.9926 14.9887V14.9857Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0405 9.06445C23.0554 9.07928 23.0702 9.09411 23.085 9.10894L23.0405 9.06445Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.085 35.3696C23.0702 35.3548 23.0554 35.343 23.0405 35.3281L23.085 35.3696Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0405 9.06445V35.3288C23.0554 35.3436 23.0702 35.3555 23.085 35.3703V9.10894C23.0702 9.09411 23.0554 9.07928 23.0405 9.06445Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9823 37.1131C24.9586 37.0894 24.9319 37.0686 24.9082 37.0449L24.9823 37.1131Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9058 10.9385C24.9295 10.9652 24.9562 10.9889 24.9799 11.0126L24.9058 10.9385Z",
    fill: "#4873B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9058 37.0456C24.9295 37.0693 24.9562 37.0901 24.9799 37.1138V11.0155C24.9562 10.9889 24.9295 10.9651 24.9058 10.9414V37.0456Z",
    fill: "#4873B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_818_2323",
    x1: 62.6191,
    y1: 26.1113,
    x2: 64.9488,
    y2: 59.7485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_818_2323",
    x1: 93.5493,
    y1: 26.1074,
    x2: 96.6148,
    y2: 59.6224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_818_2323",
    x1: 117.144,
    y1: 25.6953,
    x2: 120.118,
    y2: 60.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_818_2323",
    x1: 141.877,
    y1: 25.6953,
    x2: 144.851,
    y2: 60.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_818_2323",
    x1: 72.8901,
    y1: 67.0898,
    x2: 73.2136,
    y2: 71.3605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_818_2323",
    x1: 77.5122,
    y1: 67.0869,
    x2: 77.8601,
    y2: 71.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_818_2323",
    x1: 81.791,
    y1: 67.0156,
    x2: 82.0933,
    y2: 71.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_818_2323",
    x1: 86.8252,
    y1: 67.0869,
    x2: 87.1421,
    y2: 71.3617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_818_2323",
    x1: 91.8062,
    y1: 67.0898,
    x2: 92.107,
    y2: 71.3669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_818_2323",
    x1: 96.7783,
    y1: 67.0156,
    x2: 97.0457,
    y2: 71.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_818_2323",
    x1: 102.465,
    y1: 67.0898,
    x2: 102.841,
    y2: 71.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_818_2323",
    x1: 106.216,
    y1: 67.0156,
    x2: 106.483,
    y2: 71.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_818_2323",
    x1: 111.722,
    y1: 67.0156,
    x2: 112.02,
    y2: 71.4414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_818_2323",
    x1: 116.433,
    y1: 67.0869,
    x2: 116.702,
    y2: 71.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_818_2323",
    x1: 123.623,
    y1: 67.0371,
    x2: 123.98,
    y2: 71.4225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_818_2323",
    x1: 127.996,
    y1: 67.0156,
    x2: 128.263,
    y2: 71.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_818_2323",
    x1: 133.683,
    y1: 67.0898,
    x2: 134.058,
    y2: 71.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_818_2323",
    x1: 137.665,
    y1: 67.0869,
    x2: 137.979,
    y2: 71.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_818_2323",
    x1: 142.42,
    y1: 67.0898,
    x2: 142.744,
    y2: 71.3605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_818_2323",
    x1: 147.082,
    y1: 67.0898,
    x2: 148.856,
    y2: 70.4509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_818_2323",
    x1: 149.125,
    y1: 67.0156,
    x2: 149.392,
    y2: 71.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_818_2323",
    x1: 154.808,
    y1: 67.0898,
    x2: 155.108,
    y2: 71.3669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_818_2323",
    x1: 159.694,
    y1: 67.0371,
    x2: 160.051,
    y2: 71.4225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_818_2323",
    x1: 10.6201,
    y1: 66.5625,
    x2: 12.2404,
    y2: 66.7497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_818_2323",
    x1: 35.3149,
    y1: 10.502,
    x2: 66.1451,
    y2: 36.9032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_818_2323",
    x1: 38.3096,
    y1: 10.457,
    x2: 39.1023,
    y2: 10.4677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_818_2323",
    x1: 30.4082,
    y1: 42.0664,
    x2: 45.9059,
    y2: 66.3151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_818_2323",
    x1: 35.2466,
    y1: 13.5977,
    x2: 36.4618,
    y2: 13.6226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_818_2323",
    x1: 33.4023,
    y1: 41.9678,
    x2: 34.1947,
    y2: 41.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_818_2323",
    x1: 25.5015,
    y1: 48.2432,
    x2: 40.1425,
    y2: 72.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_818_2323",
    x1: 30.3398,
    y1: 46.3389,
    x2: 31.5535,
    y2: 46.3885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_818_2323",
    x1: 28.4956,
    y1: 48.2012,
    x2: 29.2879,
    y2: 48.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_818_2323",
    x1: 20.5913,
    y1: 53.1455,
    x2: 32.3912,
    y2: 75.3116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_818_2323",
    x1: 25.4331,
    y1: 51.2383,
    x2: 26.6468,
    y2: 51.2879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_818_2323",
    x1: 23.5889,
    y1: 53.1045,
    x2: 24.3811,
    y2: 53.1265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_818_2323",
    x1: 15.6875,
    y1: 58.0332,
    x2: 24.1858,
    y2: 77.5759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_818_2323",
    x1: 20.5264,
    y1: 56.1406,
    x2: 21.7393,
    y2: 56.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_818_2323",
    x1: 18.6816,
    y1: 57.9912,
    x2: 19.4736,
    y2: 58.0182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_818_2323",
    x1: 10.7119,
    y1: 62.9092,
    x2: 16.1083,
    y2: 79.2043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_818_2323",
    x1: 15.6191,
    y1: 61.0137,
    x2: 16.8304,
    y2: 61.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_818_2323",
    x1: 13.7749,
    y1: 62.8633,
    x2: 14.5663,
    y2: 62.8979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_818_2323",
    x1: 40.2192,
    y1: 5.63574,
    x2: 55.6917,
    y2: 29.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_818_2323",
    x1: 40.1445,
    y1: 8.60938,
    x2: 41.4636,
    y2: 8.66543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_818_2323",
    x1: 43.2109,
    y1: 5.58984,
    x2: 44.0032,
    y2: 5.61103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_818_2323",
    x1: 45.1201,
    y1: 0.741211,
    x2: 59.7421,
    y2: 24.5164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_818_2323",
    x1: 45.0464,
    y1: 3.72461,
    x2: 46.3652,
    y2: 3.78332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_818_2323",
    x1: 48.1089,
    y1: 0.699219,
    x2: 48.9012,
    y2: 0.7204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_818_2323",
    x1: 50.021,
    y1: 0,
    x2: 61.7999,
    y2: 22.1097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_818_2323",
    x1: 49.9473,
    y1: 0,
    x2: 51.2659,
    y2: 0.0612165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_818_2323",
    x1: 53.0098,
    y1: 0.0117188,
    x2: 53.8019,
    y2: 0.036622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_818_2323",
    x1: 54.9194,
    y1: 0.0185547,
    x2: 63.4137,
    y2: 19.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_818_2323",
    x1: 54.8452,
    y1: 0.0185547,
    x2: 56.1624,
    y2: 0.0933145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_818_2323",
    x1: 59.8169,
    y1: 0.0117188,
    x2: 65.2767,
    y2: 16.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_818_2323",
    x1: 57.9106,
    y1: 0.0205078,
    x2: 58.7022,
    y2: 0.0518057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_818_2323",
    x1: 59.7461,
    y1: 0.0185547,
    x2: 61.0605,
    y2: 0.114397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_818_2323",
    x1: 166.591,
    y1: 54.7539,
    x2: 166.805,
    y2: 58.3545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_818_2323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.8622e54bf7b84e3734004a109220d776.svg";
export { ForwardRef as ReactComponent };